module.exports = __webpack_public_path__ + "static/media/light-theme-geofence-alt.ea7921ed.svg";